const Stat = ({ icon: Icon, value, label }) => (
  <div className="d-flex align-items-center gap-2 text-muted">
    <Icon size={16} />
    <span className="fw-semibold">{value}</span>
    {label && <span>{label}</span>}
  </div>
);
export default Stat